import Vue from 'vue'
import Vuex from 'vuex';

// Modules
import shared from "./modules/shared.module";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        dialogConferma: {
            isVisibile: false,
            titolo: null,
            testo: null,
            onAnnulla: ()=>{},
            onConferma: ()=>{}
        },
    },
    mutations: {
        mostraDialogConferma(state, { titolo, testo, onConferma, onAnnulla }) {
            state.dialogConferma.titolo = titolo;
            state.dialogConferma.testo = testo;
            state.dialogConferma.onConferma = onConferma;
            state.dialogConferma.onAnnulla = onAnnulla;
            state.dialogConferma.isVisibile = true;
        },
        nascondiDialogConferma(state) {
            state.dialogConferma.titolo = null;
            state.dialogConferma.testo = null;
            state.dialogConferma.onConferma = ()=>{};
            state.dialogConferma.onAnnulla = ()=>{};
            state.dialogConferma.isVisibile = false;
        },
    },

    modules: {
        shared
    }
});